(function () {
    'use strict';

    let showcaseSliders = document.querySelectorAll('.mol-showcase');

    function checkArrows(swiper) {
        if (swiper.isBeginning && swiper.isEnd) {
            $(swiper.navigation.prevEl).addClass('hide-prevnext');
            $(swiper.navigation.nextEl).addClass('hide-prevnext');
        } else {
            $(swiper.navigation.prevEl).removeClass('hide-prevnext');
            $(swiper.navigation.nextEl).removeClass('hide-prevnext');
        }
    }

    for (let i = 0; i < showcaseSliders.length; i++) {
        let swiperImageContainer = showcaseSliders[i].querySelector(
            '.swiper-image-container'
        );
        let swiperTextContainer = showcaseSliders[i].querySelector(
            '.swiper-text-container'
        );

        const nextEl = showcaseSliders[i].querySelector('.swiper-next');
        const prevEl = showcaseSliders[i].querySelector('.swiper-prev');
        const paginationEl =
            showcaseSliders[i].querySelector('.swiper-pagination');

        let swiperShowcaseText = new Swiper(swiperTextContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: "fade",
            allowTouchMove: false,
            fadeEffect: {
              crossFade: true
            },
            speed: 1000,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
            // breakpoints: {
            //     0: {
            //         allowTouchMove: true,
            //     },
            //     1024: {
            //         allowTouchMove: false,
            //     }
            // },
        });

        let swiperShowcaseImage = new Swiper(swiperImageContainer, {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
            breakpoints: {
                0: {
                    allowTouchMove: true,
                },
                1024: {
                    allowTouchMove: false,
                }
            },
            thumbs: {
                swiper: swiperShowcaseText,
              },
        });

    }
})();
